// src/pages/Subscribe.js
import React, { useState } from 'react';
import BBSHeader from '../components/BBS/BBSHeader';
import BBSNav from '../components/BBS/BBSNav';
import StatusBar from '../components/BBS/StatusBar';

export default function Subscribe() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null); // 'success', 'exists', 'error'
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();

    if (!email.trim()) return;

    setLoading(true);
    setStatus(null);

    try {
      const res = await fetch('/api/subscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() }),
      });

      const data = await res.json();

      if (res.ok) {
        if (data.alreadyExists) {
          setStatus('exists');
          setMessage('THIS EMAIL IS ALREADY REGISTERED');
        } else {
          setStatus('success');
          setMessage('SYNC COMPLETE — YOU ARE NOW CONNECTED');
          setEmail('');
        }
      } else {
        setStatus('error');
        setMessage(data.error || 'TRANSMISSION FAILED');
      }
    } catch (err) {
      setStatus('error');
      setMessage('CONNECTION ERROR — TRY AGAIN');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <BBSHeader title="SYNC" subtitle="SYNC WITH THE TERMINAL" />
      <BBSNav />

      <div style={{
        maxWidth: '500px',
        margin: '0 auto',
        padding: '30px 0',
      }}>
        {/* Terminal-style intro */}
        <div style={{
          border: '1px solid #333',
          padding: '20px',
          marginBottom: '25px',
          lineHeight: '1.8',
        }}>
          <div style={{ color: '#ff0040', marginBottom: '10px', fontSize: '0.9rem' }}>
            ▓ SYNC TRANSMISSIONS ▓
          </div>
          <div style={{ color: '#00ff41', fontSize: '0.95rem' }}>
            Enter your email below to be notified
            when the terminal is updated.
          </div>
        </div>

        {/* Subscribe form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '15px' }}>
            <label style={{
              color: '#ffb000',
              display: 'block',
              marginBottom: '8px',
              fontSize: '0.85rem',
            }}>
              EMAIL:
            </label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="admin-input"
              placeholder="operator@example.com"
              style={{
                width: '100%',
                fontSize: '1rem',
                padding: '12px',
              }}
              required
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="bbs-button"
            disabled={loading || !email.trim()}
            style={{
              width: '100%',
              padding: '12px',
              fontSize: '1rem',
              marginBottom: '15px',
            }}
          >
            {loading ? 'ESTABLISHING CONNECTION...' : '► SUBMIT'}
          </button>
        </form>

        {/* Status message */}
        {status && (
          <div style={{
            padding: '15px',
            border: `1px solid ${
              status === 'success' ? '#00ff41' :
              status === 'exists' ? '#ffb000' :
              '#ff0040'
            }`,
            color: status === 'success' ? '#00ff41' :
                   status === 'exists' ? '#ffb000' :
                   '#ff0040',
            textAlign: 'center',
            fontSize: '0.95rem',
          }}>
            {status === 'success' && '✓ '}
            {status === 'exists' && '● '}
            {status === 'error' && '✗ '}
            {message}
          </div>
        )}

      </div>

      <StatusBar />
    </div>
  );
}